<button class="add_button {{addClass}}"><span class="icon"><icon-plus></icon-plus></span><ng-content></ng-content></button>
